export default {
  listClient() {
    return Request.get('api/slider_bar/client');
  },
};
